import script from "./DurataTable2.vue?vue&type=script&setup=true&lang=js"
export * from "./DurataTable2.vue?vue&type=script&setup=true&lang=js"

import "./DurataTable2.vue?vue&type=style&index=0&id=f5d94b10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5d94b10"]])

export default __exports__